var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "ResizableContent",
    {
      staticClass: "user-info-widget",
      class: { minimized: _vm.minimized },
      attrs: {
        handles: ["ml"],
        "on-resize": _vm.onResize,
        "max-width": _vm.maxUserInfoWidgetWidth,
        "min-width": _vm.minUserInfoWidgetWidth,
        width: _vm.cloneWidth,
        "disabled-resize": _vm.disabledResize,
      },
    },
    [
      !_vm.disabledResize
        ? _c(
            "div",
            { staticClass: "collapse-widget", on: { click: _vm.maximize } },
            [
              _c("div", { staticClass: "material-icons" }, [
                _vm._v("chevron_left"),
              ]),
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "user-info-head" }, [
        _c("div", { staticClass: "user-info-details user-info-widget-title" }, [
          _vm._v(_vm._s(_vm.getTabTitle())),
        ]),
        _vm._v(" "),
        _vm.minimized
          ? _c(
              "div",
              { staticClass: "material-icons", on: { click: _vm.maximize } },
              [_vm._v("add")]
            )
          : !_vm.disabledResize
          ? _c(
              "div",
              { staticClass: "material-icons", on: { click: _vm.minimize } },
              [_vm._v("close")]
            )
          : _vm._e(),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "user-info-wrapper" }, [
        _c(
          "div",
          { staticClass: "user-info-content" },
          [
            _vm.tab === "user-info"
              ? _c("ContactDetail", { attrs: { contact: _vm.contact } })
              : _vm._e(),
            _vm._v(" "),
            _vm.tab === "meta-referrals"
              ? _c("MetaReferrals", { attrs: { contact: _vm.contact } })
              : _vm._e(),
            _vm._v(" "),
            _vm.tab === "message-search"
              ? _c("MessageSearch", { attrs: { contact: _vm.contact } })
              : _vm._e(),
            _vm._v(" "),
            _vm.tab === "contact-properties"
              ? _c("ContactProperties", { attrs: { contact: _vm.contact } })
              : _vm._e(),
            _vm._v(" "),
            _vm.tab === "notes"
              ? _c("ContactNotes", { attrs: { "visitor-id": _vm.contact._id } })
              : _vm._e(),
            _vm._v(" "),
            _vm.tab === "ready-contents"
              ? _c("ReadyContents", { attrs: { contact: _vm.contact } })
              : _vm._e(),
            _vm._v(" "),
            _vm.tab === "agents"
              ? _c("AgentList", { attrs: { contact: _vm.contact } })
              : _vm._e(),
            _vm._v(" "),
            _vm.tab === "zoho"
              ? _c("ZohoWidget", { attrs: { contact: _vm.contact } })
              : _vm._e(),
            _vm._v(" "),
            _vm.tab === "media-and-document"
              ? _c("VisitorMediaAndDocuments", {
                  attrs: {
                    "visitor-id": _vm.contact._id,
                    "allow-go-to-chat-message": true,
                    "active-conversation-id": _vm.activeConversationIdForMedia,
                  },
                  on: {
                    "visitor-go-to-chat-message": function ($event) {
                      return _vm.$emit("visitor-go-to-chat-message", $event)
                    },
                  },
                })
              : _vm._e(),
            _vm._v(" "),
            _vm.tab === "flowlu" &&
            _vm.enabledFlowluSites.includes(_vm.site._id)
              ? _c("FlowluWidget", { attrs: { contact: _vm.contact } })
              : _vm._e(),
            _vm._v(" "),
            _vm.tab.startsWith("webtab-")
              ? _c("WebTabWidgetContent", {
                  attrs: {
                    webTab: _vm.getWebTabById(_vm.tab.replace("webtab-", "")),
                    contact: _vm.contact,
                  },
                })
              : _vm._e(),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "user-info-menu" },
          [
            _c(
              "div",
              {
                directives: [
                  {
                    name: "tippy",
                    rawName: "v-tippy",
                    value: { followCursor: true, placement: "right-end" },
                    expression:
                      "{ followCursor: true, placement: 'right-end' }",
                  },
                ],
                staticClass: "user-info-menu-item gray",
                class: { selected: _vm.tab === "user-info" },
                attrs: { content: _vm.$t("tour.popoverInfo") },
                on: {
                  click: function ($event) {
                    return _vm.changeTab("user-info")
                  },
                },
              },
              [_c("UserInfoSvg")],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                directives: [
                  {
                    name: "tippy",
                    rawName: "v-tippy",
                    value: { followCursor: true, placement: "right-end" },
                    expression:
                      "{ followCursor: true, placement: 'right-end' }",
                  },
                ],
                staticClass: "user-info-menu-item gray",
                class: { selected: _vm.tab === "contact-properties" },
                attrs: { content: _vm.$t("message.contactProperties") },
                on: {
                  click: function ($event) {
                    return _vm.changeTab("contact-properties")
                  },
                },
              },
              [
                _c(
                  "span",
                  {
                    staticClass: "material-icons hash-icon",
                    staticStyle: { "font-size": "30px" },
                  },
                  [_vm._v("tag")]
                ),
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                directives: [
                  {
                    name: "tippy",
                    rawName: "v-tippy",
                    value: { followCursor: true, placement: "right-end" },
                    expression:
                      "{ followCursor: true, placement: 'right-end' }",
                  },
                ],
                staticClass: "user-info-menu-item gray",
                class: { selected: _vm.tab === "notes" },
                attrs: { content: _vm.$t("message.notes") },
                on: {
                  click: function ($event) {
                    return _vm.changeTab("notes")
                  },
                },
              },
              [
                _vm.contact.noteCount
                  ? _c("div", { staticClass: "user-info-menu-item-badge" }, [
                      _vm._v(
                        "\n                    " +
                          _vm._s(_vm.contact.noteCount || 0) +
                          "\n                "
                      ),
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _c("NotesSvg"),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                directives: [
                  {
                    name: "tippy",
                    rawName: "v-tippy",
                    value: { followCursor: true, placement: "right-end" },
                    expression:
                      "{ followCursor: true, placement: 'right-end' }",
                  },
                ],
                staticClass: "user-info-menu-item gray",
                class: { selected: _vm.tab === "agents" },
                attrs: { content: _vm.$t("message.agentDetails") },
                on: {
                  click: function ($event) {
                    return _vm.changeTab("agents")
                  },
                },
              },
              [_c("AgentsSvg")],
              1
            ),
            _vm._v(" "),
            !_vm.isWatching()
              ? _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "tippy",
                        rawName: "v-tippy",
                        value: { followCursor: true, placement: "right-end" },
                        expression:
                          "{ followCursor: true, placement: 'right-end' }",
                      },
                    ],
                    staticClass: "user-info-menu-item gray",
                    class: { selected: _vm.tab === "ready-contents" },
                    attrs: { content: _vm.$t("plans.readyContents") },
                    on: {
                      click: function ($event) {
                        return _vm.changeTab("ready-contents")
                      },
                    },
                  },
                  [_c("ReadyContentsSvg")],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            !_vm.isWatching()
              ? _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "tippy",
                        rawName: "v-tippy",
                        value: { followCursor: true, placement: "right-end" },
                        expression:
                          "{ followCursor: true, placement: 'right-end' }",
                      },
                    ],
                    staticClass: "user-info-menu-item gray",
                    class: { selected: _vm.tab === "media-and-document" },
                    attrs: { content: _vm.$t("message.sumChat_MediaFile") },
                    on: {
                      click: function ($event) {
                        return _vm.changeTab("media-and-document")
                      },
                    },
                  },
                  [_c("MediaAndDocumentSVG")],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _c(
              "div",
              {
                directives: [
                  {
                    name: "tippy",
                    rawName: "v-tippy",
                    value: { followCursor: true, placement: "right-end" },
                    expression:
                      "{ followCursor: true, placement: 'right-end' }",
                  },
                ],
                staticClass: "user-info-menu-item gray",
                class: { selected: _vm.tab === "message-search" },
                attrs: { content: _vm.$t("userInfoWidget.messageSearch") },
                on: {
                  click: function ($event) {
                    return _vm.changeTab("message-search")
                  },
                },
              },
              [
                _c(
                  "span",
                  {
                    staticClass: "material-icons hash-icon",
                    staticStyle: { "font-size": "30px" },
                  },
                  [_vm._v("search")]
                ),
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                directives: [
                  {
                    name: "tippy",
                    rawName: "v-tippy",
                    value: { followCursor: true, placement: "right-end" },
                    expression:
                      "{ followCursor: true, placement: 'right-end' }",
                  },
                ],
                staticClass: "user-info-menu-item gray",
                class: { selected: _vm.tab === "meta-referrals" },
                attrs: { content: "Meta Referrals" },
                on: {
                  click: function ($event) {
                    return _vm.changeTab("meta-referrals")
                  },
                },
              },
              [_c("MetaReferralsSVG")],
              1
            ),
            _vm._v(" "),
            _vm.zohoChannelExists
              ? _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "tippy",
                        rawName: "v-tippy",
                        value: { followCursor: true, placement: "right-end" },
                        expression:
                          "{ followCursor: true, placement: 'right-end' }",
                      },
                    ],
                    staticClass: "user-info-menu-item zoho",
                    class: { selected: _vm.tab === "zoho" },
                    attrs: { content: _vm.$t("userInfoWidget.zohoInfo") },
                    on: {
                      click: function ($event) {
                        return _vm.changeTab("zoho")
                      },
                    },
                  },
                  [_c("ZohoIcon")],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.enabledFlowluSites.includes(_vm.site._id)
              ? _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "tippy",
                        rawName: "v-tippy",
                        value: { followCursor: true, placement: "right-end" },
                        expression:
                          "{ followCursor: true, placement: 'right-end' }",
                      },
                    ],
                    staticClass: "user-info-menu-item flowlu",
                    class: { selected: _vm.tab === "flowlu" },
                    attrs: { content: "Flowlu" },
                    on: {
                      click: function ($event) {
                        return _vm.changeTab("flowlu")
                      },
                    },
                  },
                  [_c("FlowluLogo")],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _vm._l(_vm.contactWidgetWebTabs, function (webTab) {
              return _c(
                "div",
                {
                  directives: [
                    {
                      name: "tippy",
                      rawName: "v-tippy",
                      value: { followCursor: true, placement: "right-end" },
                      expression:
                        "{ followCursor: true, placement: 'right-end' }",
                    },
                  ],
                  key: "webtab-" + webTab._id,
                  staticClass: "user-info-menu-item webtab-item",
                  class: { selected: _vm.tab === "webtab-" + webTab._id },
                  attrs: { content: webTab.description || webTab.name },
                  on: {
                    click: function ($event) {
                      return _vm.changeTab("webtab-" + webTab._id)
                    },
                  },
                },
                [
                  _c(
                    "span",
                    {
                      staticClass: "material-icons webtab-icon",
                      style: { color: webTab.iconColor || "#8796af" },
                    },
                    [
                      _vm._v(
                        "\n                    " +
                          _vm._s(webTab.icon) +
                          "\n                "
                      ),
                    ]
                  ),
                ]
              )
            }),
          ],
          2
        ),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }